import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-amzn-spectrum-details',
  templateUrl: './help-amzn-spectrum-details.component.html',
  styleUrls: ['./help-amzn-spectrum-details.component.scss']
})
export class HelpAmznSpectrumDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
